import Vue from "vue";
import Vuex from "vuex";

// 把store下的所有文件全部import进来“import * as”是一种特殊语法
import * as actions from "./actions";
import state from "./state";
import qmyx from "./qmyx";
import mutations from "./mutations";
Vue.use(Vuex);

export default new Vuex.Store({
  actions,
  state,
  mutations,
  modules: {
    qmyx
  }  
});
